import { jsxs, jsx } from "react/jsx-runtime";
import * as React from "react";
import { cx } from "../internal/cx.js";
import { useMediaQuery, pinQuery, DEFAULT_PIN } from "./hooks.js";
import { MenuIcon } from "./icons.js";
import { useAppShell } from "./ShellContext.js";
const TopBar = React.forwardRef(function TopBar2({ title, actions, menuLabel = "Open navigation", onMenuClick, pin, className, children, ...rest }, ref) {
  const shell = useAppShell();
  const pinned = useMediaQuery(pinQuery(shell?.pin ?? pin ?? DEFAULT_PIN));
  const opensDrawer = shell?.hasDrawer === true;
  const hasMenu = !pinned && (opensDrawer || onMenuClick != null);
  const handleMenu = () => {
    if (opensDrawer) shell.setDrawerOpen(true);
    onMenuClick?.();
  };
  return /* @__PURE__ */ jsxs("header", { ref, className: cx("ev-topbar", className), ...rest, children: [
    hasMenu && /* @__PURE__ */ jsx(
      "button",
      {
        type: "button",
        className: "ev-btn ev-btn--ghost ev-btn--icon ev-menu-button",
        "aria-label": menuLabel,
        "aria-haspopup": "dialog",
        "aria-expanded": opensDrawer ? shell.drawerOpen : void 0,
        onClick: handleMenu,
        children: /* @__PURE__ */ jsx(MenuIcon, {})
      }
    ),
    /* @__PURE__ */ jsx("div", { className: "ev-topbar__title", children: title }),
    actions != null && /* @__PURE__ */ jsx("div", { className: "ev-topbar__actions", children: actions }),
    children
  ] });
});
export {
  TopBar
};
//# sourceMappingURL=TopBar.js.map
